const mapSplit = (el) => el.split("=");
const paramsReducer = (acc, [k, v]) => {
    acc[k] = v;
    return acc;
};

export default function translateParamsToObject(getParams) {
    // empty string (no query string) would produce {"": undefined} without this guard
    if (!getParams) return {};
    return getParams.substr(1).split("&").map(mapSplit).reduce(paramsReducer, {});
}
